const translations = {
    'jobs.assistantMinus': 'Assistant -',
    'jobs.assistantPlus': 'Assistant +',
    'jobs.assistants': 'Assistants: %d/%d',
    'jobs.builderMinus': 'Builder -',
    'jobs.builderPlus': 'Builder +',
    'jobs.builders': 'Builders: %d/%d',
    'jobs.burnerMinus': 'Burner -',
    'jobs.burnerPlus': 'Burner +',
    'jobs.burners': 'Burners: %d/%d',
    'jobs.farmerMinus': 'Farmer -',
    'jobs.farmerPlus': 'Farmer +',
    'jobs.farmers': 'Farmers: %d/%d',
    'jobs.fisherMinus': 'Fisher -',
    'jobs.fisherPlus': 'Fisher +',
    'jobs.fishers': 'Fishers: %d/%d',
    'jobs.foresterMinus': 'Forester -',
    'jobs.foresterPlus': 'Forester +',
    'jobs.foresters': 'Foresters: %d/%d',
    'jobs.free': 'Free population: %d',
    'jobs.goldMinerMinus': 'Gold miner -',
    'jobs.goldMinerPlus': 'Gold miner +',
    'jobs.goldMiners': 'Gold miners: %d/%d',
    'jobs.hunterMinus': 'Hunter -',
    'jobs.hunterPlus': 'Hunter +',
    'jobs.hunters': 'Hunters: %d/%d',
    'jobs.lumberjackMinus': 'Lumberjack -',
    'jobs.lumberjackPlus': 'Lumberjack +',
    'jobs.lumberjacks': 'Lumberjacks: %d/%d',
    'jobs.masonMinus': 'Mason -',
    'jobs.masonPlus': 'Mason +',
    'jobs.masons': 'Masons: %d/%d',
    'jobs.minerMinus': 'Miner -',
    'jobs.minerPlus': 'Miner +',
    'jobs.miners': 'Miners: %d/%d',
    'jobs.minterMinus': 'Minter -',
    'jobs.minterPlus': 'Minter +',
    'jobs.minters': 'Minters: %d/%d',
    'jobs.militiaMinus': 'Militia -',
    'jobs.militiaPlus': 'Militia +',
    'jobs.militia': 'Militia: %d/%d',
    'jobs.quarrymanMinus': 'Quarryman -',
    'jobs.quarrymanPlus': 'Quarryman +',
    'jobs.quarrymen': 'Quarrymen: %d/%d',
    'jobs.sawmillerMinus': 'Sawmiller -',
    'jobs.sawmillerPlus': 'Sawmiller +',
    'jobs.sawmillers': 'Sawmillers: %d/%d',
    'jobs.section': 'Jobs',
    'jobs.smelterMinus': 'Smelter -',
    'jobs.smelterPlus': 'Smelter +',
    'jobs.smelters': 'Smelters: %d/%d',
    'jobs.smithMinus': 'Smith -',
    'jobs.smithPlus': 'Smith +',
    'jobs.smiths': 'Smiths: %d/%d',
    'jobs.smokerMinus': 'Smoker -',
    'jobs.smokerPlus': 'Smoker +',
    'jobs.smokers': 'Smokers: %d/%d',
    'jobs.weaverMinus': 'Weaver -',
    'jobs.weaverPlus': 'Weaver +',
    'jobs.weavers': 'Weavers: %d/%d',
    'jobs.name.unassigned': 'Unassigned',
    'jobs.name.assistants': 'Assistant',
    'jobs.name.builders': 'Builder',
    'jobs.name.burners': 'Burner',
    'jobs.name.farmers': 'Farmer',
    'jobs.name.fishers': 'Fisher',
    'jobs.name.foresters': 'Forester',
    'jobs.name.goldMiners': 'Gold miner',
    'jobs.name.hunters': 'Hunter',
    'jobs.name.lumberjacks': 'Lumberjack',
    'jobs.name.masons': 'Mason',
    'jobs.name.miners': 'Miner',
    'jobs.name.minters': 'Minter',
    'jobs.name.militia': 'Militia',
    'jobs.name.quarrymen': 'Quarryman',
    'jobs.name.sawmillers': 'Sawmiller',
    'jobs.name.smelters': 'Smelter',
    'jobs.name.smiths': 'Smith',
    'jobs.name.smokers': 'Smoker',
    'jobs.name.weavers': 'Weaver',
};

export default translations;
